import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { postSpringbigOfferDiscount } from 'actions/EntityActions';
// Basic Components
import Button from 'screens/components/basic/Button';
import DialogInput from 'screens/components/advanced/DialogInput';
import DialogHeader from 'screens/components/basic/DialogHeader'

const customContentStyle = {
    width: '75%',
    maxWidth: 'none'
};

class POSSpringbigOffersDialog extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            offerDetailDialogOpen: false,
            selectedOffer: null
        }
    }

    checkDetails = (offer) => {
        this.setState({
            offerDetailDialogOpen: true,
            selectedOffer: offer
        });
    }

    addToOrder = (offer) => {
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));

        let percentage = 0;
        let amount = 0;

        if (offer.discount_type && offer.discount_type == '%' && offer.discount_amount) {
            percentage = offer.discount_amount
        }
        else if (offer.discount_type && offer.discount_type == '$' && offer.discount_amount) {
            amount = offer.discount_amount
        }

        let model = {
            Id: this.props.order ? this.props.order.id : 0, BranchId: this.props.branchId,
            DeviceId: deviceData.id, Percentage: percentage,
            Amount: amount, Notes: this.props.t('pos.springbigOffers.bigOffer'),
            OfferId: offer.id ? offer.id : 0, PatientId: this.props.order ? this.props.order.patientId : 0
        };

        this.props.postSpringbigOfferDiscount(model);
        this.closeOfferDetailDialog();
        this.closeOffers()
    }

    closeOfferDetailDialog = () => {
        this.setState({ offerDetailDialogOpen: false });
    }

    closeOffers = () => {
        this.props.onClose();
    }

    render() {
        const { t } = this.props; 
        const current = new Date();
        const offers = this.props.offers.filter(x => x.active).filter(x => x.redemptions_available > 0 || x.redemptions_available == -1).filter(x => new Date(x.expiration) > current.getDate() || x.expiration == null);
        let selectedOffer = this.state.selectedOffer;

        return (
            <div>

                <DialogInput
                    open={this.props.open}
                >
                    {!offers ?
                        <div className="row m-0">
                            <div className="alert alert-warning">
                                {t('pos.springbigOffers.noOfferFound')}
                            </div>
                        </div> :
                        <div>
                            <h1>{t('pos.springbigOffers.springbigOffers')}</h1>
                            <div className="row m-0">
                                {
                                    (offers !== undefined && offers !== null) &&
                                    offers.map((offer, index) => {
                                        let redeemValid = this.props.order.subTotal <= 0.0 || !offer.discount_amount || !offer.discount_type || (offer.discount_type && offer.discount_type == "$" && offer.discount_amount && offer.discount_amount > this.props.order.subTotal);
                                        return (
                                            <div key={index} className="item-online-order">
                                                <div className="col-lg-4 col-sm-4 col-xs-4 col-md-4 mt-2">
                                                    <div>
                                                        {offer.name}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-sm-4 col-xs-4 col-md-4 btn-start">
                                                    <Button
                                                        name="finishButton"
                                                        label={t('common.viewDetails')}
                                                        className="pull-right btn-finish"
                                                        primary={true}
                                                        onTouchTap={() => this.checkDetails(offer)}
                                                    />
                                                </div>
                                                <div className="col-lg-4 col-sm-4 col-xs-4 col-md-4 btn-start">
                                                    <Button
                                                        name="finishButton"
                                                        label={t('common.redeem')}
                                                        className="pull-right btn-load-create-order"
                                                        primary={true}
                                                        onTouchTap={() => this.addToOrder(offer)}
                                                        disabled={redeemValid}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>}
                    <Button name="buttonCancel"
                        type="Button"
                        className="corner_X"
                        label=""
                        onTouchTap={() => this.closeOffers()}
                    />
                </DialogInput>
                <DialogInput
                    title={<DialogHeader text={selectedOffer ? selectedOffer.name : ""} classicClass="posDialogClassic"/>}
                    modal={true}
                    open={this.state.offerDetailDialogOpen}
                    autoScrollBodyContent={true}
                    className="online-orders-line-dialog checkIn_list"
                    handleClose={() => this.closeOfferDetailDialog()}
                    contentStyle={customContentStyle}
                >
                    {selectedOffer ?
                        <div>
                            <div className='text-center'>
                                {!selectedOffer.discount_amount || !selectedOffer.discount_type ? <h3>{t('pos.springbigOffers.discount')}: {t('pos.springbigOffers.unspecifiedLower')}</h3> : (selectedOffer.discount_type && selectedOffer.discount_type == "%" ? <h3>{t('pos.springbigOffers.discount')}: {selectedOffer.discount_amount}%</h3> : <h3>{t('pos.springbigOffers.discount')}: ${selectedOffer.discount_amount}</h3>)}
                                {selectedOffer.redemptions_available && <h4>{t('pos.springbigOffers.redemptionsAvailable')}: {selectedOffer.redemptions_available == -1 ? "unlimited" : selectedOffer.redemptions_available}</h4>}
                                {selectedOffer.expiration && <h4>{t('pos.springbigOffers.expiration')}: {(new Date(selectedOffer.expiration).getMonth() + 1) + "/" + new Date(selectedOffer.expiration).getDate() + "/" + new Date(selectedOffer.expiration).getFullYear()} </h4>}
                                ----------------------------------------------------------------
                                {selectedOffer.description && <p>{selectedOffer.description}</p>}
                                {selectedOffer.discount_type == "$" && selectedOffer.discount_amount > this.props.order.subTotal && <p className="danger">{t('pos.springbigOffers.subTotalAtLeastDiscountAmount')}</p>}
                            </div>

                            <Button name="buttonCancel"
                                type="Button"
                                className="corner_X"
                                label=""
                                onTouchTap={() => this.closeOfferDetailDialog()}
                            />
                        </div> : ""}

                </DialogInput>
            </div>

        );
    }
}



function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        offers: state.entity.springBigOffers || [],
        order: state.entity.posOrder || {},
        deviceKeyName: state.common.applicationSettings.deviceKeyName
    }
}

function mapDispatchToProps(dispatch) {
    return {
        postSpringbigOfferDiscount: (model) => dispatch(postSpringbigOfferDiscount(model))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSSpringbigOffersDialog))